"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _common = require("@insided/shared/utils/common");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LazyLoaderComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LazyLoaderComponent, _Component);

  var _super = _createSuper(LazyLoaderComponent);

  function LazyLoaderComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LazyLoaderComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      displayOriginal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", null);
    return _this;
  }

  (0, _createClass2.default)(LazyLoaderComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!_common.common.isModuleActive('lazyLoading') || (0, _globals.default)('application') === 'control' || !document.body.classList.contains('twig_site-index') || this.ref === null) {
        this.setState({
          displayOriginal: true
        });
        return;
      }

      if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
        var lazyObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // @ts-expect-error
              var lazyComponent = entry.target;
              var componentHeight = lazyComponent.offsetHeight ? lazyComponent.offsetHeight * 2 : window.innerHeight;
              var checkIfImageResizedAlready = /attachment\/(width|height)\//;
              var oldUrl = lazyComponent.dataset.src;
              var newSrc = oldUrl;

              if (!_this2.props.displayOriginalImage) {
                newSrc = oldUrl.match(checkIfImageResizedAlready) ? oldUrl : oldUrl.replace('/attachment/', "/attachment/height/".concat(componentHeight, "/"));
              }

              if (_this2.props.type === 'img') {
                lazyComponent.src = newSrc;
              } else {
                lazyComponent.style.backgroundImage = "url(".concat(newSrc, ")");
              }

              lazyComponent.classList.remove('lazy');
              lazyObserver.unobserve(lazyComponent);
            }
          });
        });
        lazyObserver.observe(this.ref);
      } else {
        this.setState({
          displayOriginal: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          type = _this$props.type,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          src = _this$props.src,
          srcSet = _this$props.srcSet,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$alt = _this$props.alt,
          alt = _this$props$alt === void 0 ? '' : _this$props$alt,
          className = _this$props.className;
      var displayOriginal = this.state.displayOriginal;
      var isBrowser = typeof window !== 'undefined';
      var imageDescription = alt || title; // Always use proper accessibility behavior

      var imageRole = imageDescription !== '' ? 'img' : 'presentation';

      if (displayOriginal) {
        if (type === 'img') {
          return (0, _preact.h)("img", {
            role: imageRole,
            className: className,
            src: (0, _absoluteUrlRuntime.resolveUrl)(src),
            srcSet: srcSet,
            style: style,
            title: title,
            alt: imageDescription
          });
        } else if (type === 'background') {
          return (0, _preact.h)("div", {
            role: imageRole,
            "aria-label": imageDescription,
            className: className,
            style: _objectSpread(_objectSpread({}, style), {}, {
              backgroundImage: "url(".concat(src, ")")
            })
          }, children);
        }
      }

      if (type === 'img') {
        return (0, _preact.h)("img", {
          ref: function ref(_ref) {
            _this3.ref = _ref;
          },
          role: imageRole,
          src: (0, _absoluteUrlRuntime.resolveUrl)(isBrowser ? undefined : src),
          srcSet: srcSet,
          className: (0, _classnames.default)('lazy', className),
          "data-src": src,
          style: style,
          title: title,
          alt: imageDescription
        });
      }

      return (0, _preact.h)("div", {
        role: imageRole,
        "aria-label": imageDescription,
        ref: function ref(_ref2) {
          _this3.ref = _ref2;
        },
        className: (0, _classnames.default)('lazy', className),
        "data-src": src,
        style: isBrowser ? undefined : {
          backgroundImage: src
        }
      }, ' ', children, ' ');
    }
  }]);
  return LazyLoaderComponent;
}(_preact.Component);

var LazyImage = function LazyImage(props) {
  return (0, _preact.h)(LazyLoaderComponent, props);
};

var _default = LazyImage;
exports.default = _default;